<template>
  <div class="transmission-oil-recommend">
    <!-- Banner列表 -->
    <!-- <banner></banner> -->
    <!-- 油品信息 -->
    <div
      class="intro"
      :class="`active-${current_oil_index + 1}-bg`"
      v-if="JSON.stringify(maintainInfo) != '{}'"
    >
      <div class="title-box">
        <div class="title-item" v-for="(item, index) in tabs" :key="item.key">
          <div class="title" @click="switchTab(item.key, index)">
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="product-imgs">
        <template class="product-item" v-if="current_oils.length > 0">
          <div v-for="item in current_oils" :key="item.nickName" class="item">
            <img :src="item.imageUrls[0]" alt="变速箱油图片" />
            <div class="right">
              <span class="product-name">{{ item.nickName }}</span>
              <!-- <div class="price-box" v-if="item.sell_price > 0">
                <span class="unit">￥</span>
                <span class="price-text">{{ item.sell_price / 100 }}/L</span>
              </div> -->
            </div>
          </div>
        </template>
        <div class="empty" v-else>
          <img
            class="empty-img"
            src="https://select-oil-oss.vchangyi.com/wxapp/icon-engine-oil-empty.png"
          />
          <span>特殊变速箱（干式双离合、10AT等）暂无适配产品</span>
        </div>
      </div>
    </div>
    <!-- 养护信息 -->
    <div class="detail" v-if="JSON.stringify(maintainInfo) != '{}'">
      <div class="sub-title">养护信息</div>
      <div class="list">
        <div
          class="item"
          v-if="maintainInfo.gbDescribe || maintainInfo.datumFileNumber"
        >
          <div class="title">变速箱/档位</div>
          <div class="content">
            {{ maintainInfo.gbDescribe ? maintainInfo.gbDescribe : "--" }}/{{
              maintainInfo.datumFileNumber ? maintainInfo.datumFileNumber : "--"
            }}
          </div>
        </div>
        <div class="item" v-if="maintainInfo.gbNo || maintainInfo.company">
          <div class="title">型号/厂家</div>
          <div class="content">
            <div>
              {{
                `${maintainInfo.gbNo ? maintainInfo.gbNo : "--"} / ${
                  maintainInfo.company ? maintainInfo.company : "--"
                }`
              }}
            </div>
            <div>
              <span v-if="imgList[3].length > 0"
                >（<span
                  class="click-text"
                  v-if="imgList[3].length > 0"
                  @click="preview(imgList[3])"
                  >铭牌图</span
                >）</span
              >
            </div>
          </div>
          <!-- <div class="content">DL382/0CK/大众（名牌图）</div> -->
        </div>
        <div
          class="item"
          v-if="maintainInfo.manualOil || maintainInfo.machineOil"
        >
          <div class="title">换油量</div>
          <div class="content">
            <div>
              {{
                maintainInfo.manualOil
                  ? `重力：${maintainInfo.manualOil}L`
                  : "--"
              }}
            </div>
            <div>
              {{
                maintainInfo.machineOil
                  ? `机器：${maintainInfo.machineOil} ${
                      !isNaN(Number(maintainInfo.machineOil)) ? "L" : ""
                    }`
                  : "--"
              }}
            </div>
          </div>
        </div>
        <div class="item" v-if="maintainInfo.frontReducer">
          <div class="title">前减速器油</div>
          <div class="content">
            {{
              maintainInfo.frontReducer ? `${maintainInfo.frontReducer}L` : "--"
            }}
          </div>
        </div>
        <div class="item" v-if="maintainInfo.backReducer">
          <div class="title">后减速器油</div>
          <div class="content">
            {{
              maintainInfo.backReducer ? `${maintainInfo.backReducer}L` : "--"
            }}
          </div>
        </div>
        <div class="item" v-if="maintainInfo.gearBoxOil">
          <div class="title">齿轮箱油</div>
          <div class="content">
            {{ maintainInfo.gearBoxOil ? `${maintainInfo.gearBoxOil}L` : "--" }}
          </div>
        </div>
        <div class="item" v-if="maintainInfo.electUnitOil">
          <div class="title">机电单元油</div>
          <div class="content">
            {{
              maintainInfo.electUnitOil ? `${maintainInfo.electUnitOil}L` : "--"
            }}
          </div>
        </div>
        <div class="item" v-if="maintainInfo.gearboxClutch">
          <div class="title">变速箱离合器油</div>
          <div class="content">
            {{
              maintainInfo.gearboxClutch
                ? `${maintainInfo.gearboxClutch}L`
                : "--"
            }}
          </div>
        </div>
        <div class="item" v-if="gearbox_adapter.length > 0">
          <div class="title">接头(A)</div>
          <div class="content">
            <span v-if="gearbox_adapter.length > 0">
              <span v-for="(item, index) in gearbox_adapter" :key="index">
                <span>{{ item.supplierCode }}</span>
                <span
                  >（<span
                    class="click-text"
                    v-if="item.imageUrls.length > 0"
                    @click="preview(item.imageUrls)"
                    >图</span
                  >）</span
                >
                <img v-show="false" :src="item.imageUrls[0]" alt="" />
              </span>
            </span>
          </div>
        </div>
        <div class="item" v-if="maintainInfo.accInstead">
          <div class="title">养护套装</div>
          <div class="content">
            {{ maintainInfo.accInstead ? `${maintainInfo.accInstead}` : "--" }}
            <span
              class="click-text"
              @click="dialogShow = true"
              v-if="true || maintainInfo.accInstead === '无法更换'"
              >详细</span
            >
          </div>
        </div>
        <div class="item" v-if="maintainInfo.advice">
          <div class="title">技师建议</div>
          <div class="content">
            {{ maintainInfo.advice ? maintainInfo.advice : "--" }}
          </div>
        </div>
      </div>
    </div>
    <!-- 备注说明 -->
    <div class="note" v-if="imgsList.length > 0">
      <div class="item">
        <div class="title">备注说明</div>
        <div class="content">详情可见备注说明</div>
      </div>
      <div class="imgs">
        <div
          class="imgbox imgbox1"
          v-if="imgList[0].length > 0"
          @click="preview(imgList[0])"
        >
          <div class="img-box">
            <img :src="imgList[0][0]" alt="" />
            <div class="count">
              <i class="iconfont icon-tupian font-13"></i
              ><span>{{ imgList[0].length }}</span>
            </div>
          </div>
          <div class="desc">检查口/加注口/放油口</div>
        </div>
        <div
          class="imgbox imgbox2"
          v-if="imgList[1].length > 0"
          @click="preview(imgList[1])"
        >
          <div class="img-box">
            <img :src="imgList[1][0]" alt="" />
            <div class="count">
              <i class="iconfont icon-tupian font-13"></i
              ><span>{{ imgList[1].length }}</span>
            </div>
          </div>
          <div class="desc">接头位置（A）</div>
        </div>
        <div
          class="imgbox imgbox3"
          v-if="imgList[2].length > 0"
          @click="preview(imgList[2])"
        >
          <div class="img-box">
            <img :src="imgList[2][0]" alt="" />
            <div class="count">
              <i class="iconfont icon-tupian font-13"></i
              ><span>{{ imgList[2].length }}</span>
            </div>
          </div>
          <div class="desc">原厂换油</div>
        </div>
      </div>
    </div>
    <!-- 联系客服 -->
    <div
      v-if="
        loaded && !(JSON.stringify(maintainInfo) === '{}' && oilsInfoIsEmpty)
      "
      class="contact-us"
    >
      <div class="sub-title">联系客服</div>
      <span class="service-time">客服时间：9:00-17:00</span>
      <a class="call-button" href="tel:4006879616">电话客服</a>
    </div>
    <!-- 常见问题 -->
    <div
      v-if="
        loaded && !(JSON.stringify(maintainInfo) === '{}' && oilsInfoIsEmpty)
      "
      class="QA"
    >
      <div class="sub-title">常见问题</div>
      <Collapse :list="QAList" />
    </div>
    <!-- 页面空状态 -->
    <div
      class="all-empty"
      v-if="JSON.stringify(maintainInfo) === '{}' && oilsInfoIsEmpty"
    >
      <div class="empty-box">
        <img
          src="https://select-oil-oss.vchangyi.com/wxapp/no-product-bg.png"
          class="empty-img"
          alt="empty"
        />
        <span>壳牌暂无适配变速箱油品～</span>
      </div>
    </div>
    <!-- 预加载图片 -->
    <div class="cacheImgs" v-if="imgsList.length > 0" v-show="false">
      <img v-for="(item, index) in imgsList" :key="index" :src="item" alt="" />
    </div>
    <!-- dialog -->
    <div class="dialog" @touchmove.prevent v-if="dialogShow">
      <div class="dialog-box">
        <div class="title">提示</div>
        <div class="content">
          由于变速箱结构问题，该车滤网为内置，常规保养无法拆卸更换，只有大修拆解变速箱方可进行更换。如果是干式双离合的变速箱则没有滤网。
        </div>
        <div class="btns" @click="dialogShow = false">我知道了</div>
      </div>
    </div>
    <van-popup
      v-model="note_visible"
      :style="{ height: '84vw' }"
      round
      position="bottom"
    >
      <div class="popup-content">
        <div class="top">
          <div class="popup-title">选择备注</div>
          <div class="close-icon" @click="closePopup">
            <img
              src="https://select-oil-oss.vchangyi.com/wxapp/icon-gray-close.png"
              alt=""
            />
          </div>
        </div>
        <div class="line"></div>
        <van-cell
          v-for="item in popup_options"
          :key="item.label"
          :title="item.label"
          is-link
          @click="tapSubOption(item)"
        />
      </div>
    </van-popup>
  </div>
</template>
<script>
import api from "@/apis/maintenance-api.js";
import { transmissionScene } from "@/store/scenes";
import { QAList } from "@/store/constants";
import { setStatistics } from "@/utils/common";
import Collapse from "@/components/Collapse";
import { userQueryCarModelRecord } from "@/utils/data-burial";
import validToken from "@/mixins/valid-token.js";
import { Cell, Popup } from "vant";
// import Banner from "@/views/maintenance/components/Banner.vue";
export default {
  name: "transmission-oil-recommend",
  props: {
    query: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Collapse,
    VanPopup: Popup,
    VanCell: Cell,
  },
  // components: {
  //   Collapse,
  //   Banner,
  // },
  mixins: [validToken],
  data() {
    return {
      note_visible: false,
      popup_options: [],
      dialogShow: false,
      oilsInfo: {},
      maintainInfo: {},
      imgList: [[], [], [], []],
      gearbox_adapter: [], //养护信息-接头
      QAList: QAList,
      loaded: false,
      vehicle_id: "",
      vehicle_ids: [],
      current_oil_index: 0, // 当前变速箱油tab
      current_oils: [],
      oilsInfoIsEmpty: false,
      oilsInfoObj: {
        0: "变速箱油",
        1: "前减速器油",
        2: "后减速器油",
      },
      tabs: [],
      tab_list: [
        {
          title: "变速箱油",
          key: "transmission_fluid",
        },
        {
          title: "前减速器油",
          key: "front_reducer_oil",
        },
        {
          title: "后减速器油",
          key: "after_reducer_oil",
        },
      ],
    };
  },
  computed: {
    imgsList() {
      // return [];
      return this.imgList ? this.imgList.flat() : [];
    },
  },
  async mounted() {
    this.vehicle_ids = decodeURIComponent(this.query.vehicle_ids).split(","); //获取动态的参数
    this.dynamic_vehicle_ids_query = encodeURIComponent(
      this.vehicle_ids.join(",")
    );
    await this.fetchDetail();
    await this.queryDataRecord();
    this.loaded = true;
  },
  methods: {
    /**
     * @description 变速箱tab切换
     * @param {Number} id 当前数据的id
     * @param {string}
     */
    switchTab(key, tab) {
      console.log(this.current_oil_index, tab);
      tab = Number(tab);
      if (this.current_oil_index === tab) return;
      this.current_oil_index = tab;
      this.current_oils = this.oilsInfo[key];
      console.log(tab);
      console.log(this.current_oil_index);
    },
    closePopup() {
      this.note_visible = false;
    },
    tapSubOption({ tag, key }) {
      if (tag === "front") {
        this.current_oils = this.oilsInfo.front_reducer_oil.find(
          (i) => i.key === key
        ).oil_list;
      } else if (tag === "after") {
        this.current_oils = this.oilsInfo.after_reducer_oil.find(
          (i) => i.key === key
        ).oil_list;
      }
      this.note_visible = false;
      this.current_oil_index = tag === "front" ? 1 : 2;
    },
    // idx- 当前图片组具体图片索引
    preview(imgsArr, idx = 0) {
      this.$imagePreview({
        images: imgsArr,
        index: idx,
        defaultOpt: {
          fullscreenEl: false,
          arrowEl: true,
          preloaderEl: true,
          bgOpacity: 0.85,
          preload: [1, 1],
          showHideOpacity: true,
          showAnimationDuration: 0,
        },
      });
    },
    async fetchDetail() {
      await this.fetchValidToken();
      if (!this.token) return;
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        parts_type: 2,
        vehicle_ids: this.vehicle_ids,
        token: this.token,
        scheme_id,
      };
      try {
        // 优先取缓存数据
        let cacheDetail = null;
        const gearboxOilCacheString = sessionStorage.getItem("gearboxOilCache");
        if (
          gearboxOilCacheString &&
          JSON.parse(gearboxOilCacheString).key ===
            this.dynamic_vehicle_ids_query
        ) {
          cacheDetail = JSON.parse(gearboxOilCacheString).value;
        }
        cacheDetail && this.$loading.show("加载中...");
        const res = cacheDetail || (await api.getModelDetail(params));

        if (
          res.code !== 0 &&
          (res.code === 40800 ||
            res.code === 40700 ||
            res.code === 40900 ||
            res.code === 40910)
        ) {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
          return;
        }
        sessionStorage.setItem(
          "gearboxOilCache",
          JSON.stringify({
            key: encodeURIComponent(this.vehicle_ids.join(",")),
            value: res,
          })
        );
        this.vehicle_id =
          res.data.vehicle_list && res.data.vehicle_list[0]
            ? res.data.vehicle_list[0].id
            : this.query.id
            ? this.query.id
            : "";
        // console.log(res.data);
        // 设置油品信息
        // console.log(this.query.key);
        /* 这里对变速箱油的数据进行整合处理，油品信息按类型返回：其中 oil_info的结构为{
				transmission_fluid :[{}] 当前key对应的油品数组
				front_reducer_oil:[] 
				after_reducer_oil:[] 
        }
        transmission_fluid-变速箱油；front_reducer_oil-前减速器油；after_reducer_oil-后减速器油
        */
        let temp_oil_info = {
          transmission_fluid: [],
          front_reducer_oil: [],
          after_reducer_oil: [],
        };
        // 设置油品信息
        if (this.query.key === "default" || !this.query.key) {
          temp_oil_info.transmission_fluid =
            res.data.parts_list.transmission_fluid &&
            res.data.parts_list.transmission_fluid[0]
              ? res.data.parts_list.transmission_fluid[0].part_detail
              : [];
          temp_oil_info.front_reducer_oil =
            res.data.parts_list.front_reducer_oil &&
            res.data.parts_list.front_reducer_oil[0]
              ? res.data.parts_list.front_reducer_oil[0].part_detail
              : [];
          temp_oil_info.after_reducer_oil =
            res.data.parts_list.after_reducer_oil &&
            res.data.parts_list.after_reducer_oil[0]
              ? res.data.parts_list.after_reducer_oil[0].part_detail
              : [];
          this.gearbox_adapter =
            res.data.parts_list &&
            res.data.parts_list.transmission_fluid &&
            res.data.parts_list.transmission_fluid[0]
              ? res.data.parts_list.transmission_fluid[0].gearbox_adapter
              : []; //养护-接头信息
        } else {
          let curInfo =
            res.data.parts_list &&
            res.data.parts_list.transmission_fluid &&
            res.data.parts_list.transmission_fluid.length > 0
              ? res.data.parts_list.transmission_fluid.find(
                  (i) => i.key == this.query.key
                )
              : [];
          let cur_front_reducer_oil =
            res.data.parts_list &&
            res.data.parts_list.front_reducer_oil &&
            res.data.parts_list.front_reducer_oil.length > 0
              ? res.data.parts_list.front_reducer_oil.find(
                  (i) => i.key == this.query.key
                )
              : [];
          let cur_after_reducer_oil =
            res.data.parts_list &&
            res.data.parts_list.after_reducer_oil &&
            res.data.parts_list.after_reducer_oil.length > 0
              ? res.data.parts_list.after_reducer_oil.find(
                  (i) => i.key == this.query.key
                )
              : [];
          // console.log(111, curInfo);
          temp_oil_info.transmission_fluid = curInfo.part_detail
            ? curInfo.part_detail
            : [];
          temp_oil_info.front_reducer_oil = cur_front_reducer_oil.part_detail
            ? cur_front_reducer_oil.part_detail
            : [];
          temp_oil_info.after_reducer_oil = cur_after_reducer_oil.part_detail
            ? cur_after_reducer_oil.part_detail
            : [];
          this.gearbox_adapter = curInfo.gearbox_adapter; //养护-接头信息
        }
        this.oilsInfo = temp_oil_info;
        const keys = Object.keys(temp_oil_info).filter(
          (i) => temp_oil_info[i] && temp_oil_info[i].length > 0
        );
        this.oilsInfoIsEmpty = keys.length > 0 ? false : true;
        if (keys.length === 0) {
          this.current_oil_index = -1;
        }
        this.tabs = this.tab_list.filter((i) => keys.includes(i.key));
        this.current_oils =
          keys && keys.length > 0 ? temp_oil_info[keys[0]] : [];
        // 设置养护信息
        if (this.query.key == "default" || !this.query.key) {
          if (res.data.datum_list.length > 0) {
            let maintainTemp = res.data.datum_list[0].datum_detail.datumAttrs;
            this.maintainInfo = maintainTemp.reduce((res, cur) => {
              res[`${cur.attrKey}`] = cur.attrValue;
              return res;
            }, {});
            this.maintainInfo.datumImages =
              res.data.datum_list[0].datum_detail.datumImages;
          }
        } else {
          let maintainTemp = res.data.datum_list.find(
            (i) => i.key === this.query.key
          );
          // console.log(111, maintainTemp);
          this.maintainInfo = maintainTemp.datum_detail.datumAttrs;
          this.maintainInfo = this.maintainInfo.reduce((res, cur) => {
            res[`${cur.attrKey}`] = cur.attrValue;
            return res;
          }, {});
          this.maintainInfo.datumImages = maintainTemp.datum_detail.datumImages;
        }
        this.sortImgs();
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
      console.log("this.oilsInfo", this.oilsInfo);
      // console.log("this.maintainInfo", this.maintainInfo);
    },
    // 整理收集图片组
    sortImgs() {
      if (
        this.maintainInfo.datumImages &&
        this.maintainInfo.datumImages.length > 0
      ) {
        let tempImgsArr = this.maintainInfo.datumImages;
        let temp1 = tempImgsArr
          .filter(
            (i) =>
              i.resName === "检查口" ||
              i.resName === "加注口" ||
              i.resName === "放油口"
          )
          .map((i) => i.resUrl);
        let temp2 = tempImgsArr
          .filter((i) => i.resName === "接头位置(A)")
          .map((i) => i.resUrl);
        let temp3 = tempImgsArr
          .filter((i) => i.resName === "原厂换油")
          .map((i) => i.resUrl);
        let temp4 = tempImgsArr
          .filter((i) => i.resName === "铭牌图")
          .map((i) => i.resUrl);
        temp1.length == 0 ? (temp1 = []) : "";
        temp2.length == 0 ? (temp2 = []) : "";
        temp3.length == 0 ? (temp3 = []) : "";
        temp4.length == 0 ? (temp4 = []) : "";
        this.imgList = [temp1, temp2, temp3, temp4];
        if (
          temp1.length == 0 &&
          temp2.length == 0 &&
          temp3.length == 0 &&
          temp4.length == 0
        ) {
          this.imgsList = [];
        }
        // console.log(111, this.imgList);
      }
    },
    // 查询数据记录
    async queryDataRecord() {
      if (!window.localStorage.getItem("OILUSER")) {
        await setStatistics.apply(this, []);
      }
      const uuid = window.localStorage.getItem("OILUSER")
        ? Number(window.localStorage.getItem("OILUSER"))
        : "";
      const { internal_from } = this.query;
      const {
        brand_name,
        model_alias,
        factory_name,
        sales_name,
        displacement,
      } = this.query;
      const basic_info = {
        choose_vehicle_id: this.vehicle_ids[0],
        menu_type: 2,
        uuid: uuid,
        scheme_id: this.query.scheme_id,
        search_type:
          internal_from === "photo_vin"
            ? 2
            : internal_from === "text_vin"
            ? 3
            : 1,
        brand_name,
        model_alias,
        displacement,
        factory_name,
        sales_name,
      };
      await userQueryCarModelRecord.apply(this, [basic_info]);
    },
  },

  beforeRouteLeave(to, from, next) {
    if (transmissionScene.includes(to.name)) {
      next();
    } else {
      sessionStorage.removeItem("current");
      next();
    }
  },
};
</script>
<style lang="less" scoped>
.click-text {
  color: #2379ce;
  text-decoration: underline;
}
.transmission-oil-recommend {
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  // 油品信息
  .intro {
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.5);
    border-radius: 20/100rem;
    margin-bottom: 26/100rem;
    display: flex;
    flex-direction: column;
    .title-box {
      display: flex;
      width: 100%;
      .title-item {
        width: 33.33%;
        color: #333;
      }
      .title {
        // padding: 27/100rem 56/100rem 51/100rem 27/100rem;
        width: 100%;
        height: 88/100rem;
        line-height: 88/100rem;
        text-align: center;
        margin-bottom: 24/100rem;
        font-size: 24/100rem;
        font-weight: 500;
      }
    }
    .product-imgs {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      // align-items: center;
      padding: 0 27/100rem;

      .item {
        display: flex;
        text-align: center;
        font-size: 24/100rem;
        margin-bottom: 15/100rem;
        height: 133/100rem;
        width: 100%;
        color: #404040;
        align-items: center;
        img {
          width: 123/100rem;
          height: 123/100rem;
          margin-right: 16/100rem;
          border-radius: 9/100rem;
          border: 1/100rem solid #eeeeee;
          // box-shadow: 0 3/100rem 20/100rem 0 rgba(0, 0, 0, 0.05);
          flex-shrink: 0;
        }
        .right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          line-height: 34/100rem;
          padding: 5/100rem 0;
          .product-name {
            color: #333333;
            font-size: 20/100rem;
          }
          .price-box {
            display: flex;
            font-size: 24/100rem;
            .unit {
              font-weight: bold;
              color: #ce4747;
              font-size: 24/100rem;
            }
            .price-text {
              font-weight: bold;
              color: #ce4747;
            }
          }
        }
      }
      .empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        margin-bottom: 49/100rem;
        .empty-img {
          width: 133/100rem;
          height: 133/100rem;
          margin-bottom: 10/100rem;
        }
        span {
          color: #666666;
          font-size: 24/100rem;
          text-align: center;
        }
      }
    }
  }
  .active-1-bg {
    background: url(https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/active-1-bg.png)
      no-repeat;
    background-size: 100% auto;
  }
  .active-2-bg {
    background: url(https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/active-2-bg.png)
      no-repeat;
    background-size: 100% auto;
  }
  .active-3-bg {
    background: url(https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/active-3-bg.png)
      no-repeat;
    background-size: 100% auto;
  }
  // 养护信息
  .detail {
    background-color: #fff;
    padding: 26/100rem;
    margin-bottom: 26/100rem;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.5);
    border-radius: 20/100rem;
    .sub-title {
      font-weight: 600;
      color: #404040;
      font-size: 27/100rem;
      margin: 9/100rem 0 8/100rem 0;
    }
    .list {
      display: flex;
      flex-direction: column;
      .item {
        display: flex;
        justify-content: space-between;
        // align-items: center;
        padding: 19/100rem 0;
        .title {
          font-size: 24/100rem;
          font-weight: 400;
          color: #999999;
          white-space: nowrap;
          margin-right: 20/100rem;
        }
        .content {
          color: #666666;
          font-size: 24/100rem;
          text-align: right;
        }
      }
    }
  }
  // 备注说明
  .note {
    background-color: #fff;
    // margin-top: 26/100rem;
    margin-bottom: 26/100rem;
    padding: 0 26/100rem;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.5);
    border-radius: 20/100rem;
    .item {
      display: flex;
      justify-content: space-between;
      margin: 24/100rem 0 26/100rem 0;
      font-size: 24/100rem;
      align-items: center;
      .title {
        font-size: 27/100rem;
        color: #404040;
        font-weight: bold;
      }
      .content {
        color: #999999;
        font-size: 20/100rem;
      }
    }
    .imgs {
      display: flex;
      flex-direction: column;
      .imgbox {
        width: 100%;
        height: 123/100rem;
        display: flex;
        color: #404040;
        text-align: center;
        margin-bottom: 26/100rem;
        font-size: 20/100rem;
        .img-box {
          width: 123/100rem;
          height: 123/100rem;
          border-radius: 9/100rem;
          border: 1/100rem solid #eeeeee;
          margin-bottom: 26/100rem;
          display: flex;
          position: relative;
          z-index: 1;
          flex-shrink: 0;
          margin-right: 17/100rem;
          img {
            width: 123/100rem;
            height: 123/100rem;
            object-fit: scale-down;
          }
          .count {
            background: rgba(0, 0, 0, 0.6);
            height: 24/100rem;
            padding: 2/100rem 9/100rem;
            color: #fff;
            font-size: 14/100rem;
            border-radius: 15/100rem;
            position: absolute;
            right: 9/100rem;
            bottom: 9/100rem;
            display: flex;
            align-items: center;
            i {
              margin-right: 2/100rem;
              font-size: 14/100rem;
              font-weight: 200;
            }
          }
        }
        .desc {
          color: #333333;
          font-size: 20/100rem;
        }
      }
    }
  }
  // 联系客服
  .contact-us {
    width: 100%;
    padding: 26/100rem 27/100rem;
    background-color: #fff;
    margin-bottom: 26/100rem;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.5);
    border-radius: 20/100rem;
    .sub-title {
      font-weight: 600;
      color: #404040;
      font-size: 27/100rem;
      margin-bottom: 17/100rem;
    }
    .service-time {
      color: #999999;
      font-size: 24/100rem;
      margin-bottom: 17/100rem;
    }
    .call-button {
      width: 147/100rem;
      height: 55/100rem;
      background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
      box-shadow: 0px 3/100rem 20/100rem 0px rgba(251, 220, 106, 1);
      border-radius: 40/100rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333300;
      font-size: 24/100rem;
      font-weight: bold;
      line-height: 0;
    }
    .contact-us-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .phone-icon {
        width: 114/100rem;
        height: 114/100rem;
        margin-bottom: 24/100rem;
        background: url(../../../assets/maintenance/Landline-phone-icon.png)
          no-repeat center center;
        background-size: cover;
      }
      .phone-btn {
        display: inline-block;
        width: 295/100rem;
        height: 61/100rem;
        background: #fbce07;
        border-radius: 31/100rem;
        color: #ffffff;
        text-align: center;
        line-height: 61/100rem;
      }
      span {
        margin-top: 17/100rem;
        color: #a1a1a1;
        font-size: 24/100rem;
      }
    }
  }
  // 常见问题
  .QA {
    width: 100%;
    height: auto;
    padding: 26/100rem 17/100rem;
    padding-bottom: 0;
    background-color: #fff;
    margin-bottom: 60/100rem;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.5);
    border-radius: 20/100rem;
    display: flex;
    flex-direction: column;
    .sub-title {
      font-weight: 600;
      color: #404040;
      font-size: 27/100rem;
      margin-bottom: 26/100rem;
    }
  }
  .view-box {
    width: 100%;
    position: absolute;
  }
}
.all-empty {
  height: 70vh;
  display: flex;
  justify-content: center;
  .empty-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .empty-img {
      // margin-top: 208/100rem;
      width: 133/100rem;
      height: 133/100rem;
    }
    span {
      margin-top: 26/100rem;
      font-size: 24/100rem;
      color: #666666;
    }
  }
}
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: rgba(00, 00, 00, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation: dialog-fadein 0.4s;
  .dialog-box {
    width: 80%;
    height: auto;
    background: #fff;
    margin: 0 auto;
    padding: 30/100rem;
    display: flex;
    flex-direction: column;
    animation: dialog-zoom 0.4s;
    border-radius: 20/100rem;
    .title {
      margin-bottom: 20/100rem;
      font-weight: bold;
    }
    .content {
      font-size: 24/100rem;
      color: #333;
      line-height: 40/100rem;
    }
    .btns {
      width: 100%;
      text-align: center;
      margin-top: 20/100rem;
      color: #7ba1e7;
      font-size: 26/100rem;
      margin-bottom: 10/100rem;
    }
  }
}
@keyframes dialog-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes dialog-zoom {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.required::before {
  content: "* ";
  color: #d51317;
}
.popup-content {
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 85/100rem;
    .popup-title {
      color: #333333;
      font-size: 24/100rem;
      font-weight: bold;
      margin-left: 27/100rem;
    }
    .close-icon {
      width: 85/100rem;
      height: 85/100rem;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 31/100rem;
        height: 31/100rem;
      }
    }
  }
  .line {
    width: 587/100rem;
    margin: 0 auto;
    height: 2/100rem;
    background: #f6f6f6;
  }
}
</style>
